// extracted by mini-css-extract-plugin
module.exports = {"small_statistics_container":"SmallCharts_small_statistics_container__TFWCc","button_switch":"SmallCharts_button_switch__3dicV","active":"SmallCharts_active__3Nyez"};